<div class="legalese-footer">
    {{ thisYear }} &copy; kinetek. all rights reserved.
</div>
